import { render, staticRenderFns } from "./DishDiscountSetting.vue?vue&type=template&id=6777fe34&scoped=true&"
import script from "./DishDiscountSetting.vue?vue&type=script&lang=js&"
export * from "./DishDiscountSetting.vue?vue&type=script&lang=js&"
import style0 from "./DishDiscountSetting.vue?vue&type=style&index=0&id=6777fe34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6777fe34",
  null
  
)

export default component.exports